var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('ClientOnly', [_c('Row', {
    staticClass: "container"
  }, [_c('Col', {
    staticClass: "nav-left",
    attrs: {
      "span": "4"
    }
  }, [_c('RouterLink', {
    attrs: {
      "to": "/seller-center/home"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require("../assets/img/logo/nav-logo.png"),
      "alt": "logo"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "menu-dev",
    style: _vm.styleObj
  }, [_c('Menu', {
    ref: "menu",
    attrs: {
      "accordion": true,
      "width": "100%",
      "active-name": _vm.activeMenuId,
      "open-names": _vm.openedSubmenuIds
    },
    on: {
      "on-select": _vm.handleSelectMenu
    }
  }, [_c('MenuItem', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "name": 1,
      "to": "/seller-center/home"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-home"
  }), _vm._v("\n              " + _vm._s(_vm.$t('sc.sellerCenter.home')) + "\n            ")]), _vm._v(" "), _vm._l(_vm.menu, function (item) {
    return _c('Submenu', {
      key: item.id,
      attrs: {
        "name": item.id
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function () {
          return [item.id === 4 ? _c('Badge', {
            attrs: {
              "count": _vm.messageNotReadTotal
            }
          }, [_c('span', {
            staticStyle: {
              "padding-right": "10px"
            }
          }, [_c('i', {
            class: ("iconfont " + (_vm.menuId2Icon[item.id]))
          }), _vm._v("\n                    " + _vm._s(_vm.$t(item.name)) + "\n                  ")])]) : item.id === 9 && !_vm.whatsappNumber && Number(_vm.$cookies.get('sellerRegionId')) !== 2 ? _c('Badge', {
            attrs: {
              "dot": ""
            }
          }, [_c('span', {
            staticStyle: {
              "padding-right": "10px"
            }
          }, [_c('i', {
            class: ("iconfont " + (_vm.menuId2Icon[item.id]))
          }), _vm._v("\n                    " + _vm._s(_vm.$t(item.name)) + "\n                  ")])]) : _c('span', [_c('i', {
            class: ("iconfont " + (_vm.menuId2Icon[item.id]))
          }), _vm._v("\n                  " + _vm._s(_vm.$t(item.name)) + "\n                ")])];
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l(item.pages, function (subItem) {
      return _c('MenuItem', {
        key: subItem.id,
        attrs: {
          "name": subItem.id,
          "to": ("/seller-center/" + (subItem.url))
        }
      }, [subItem.id === 47 ? _c('Badge', {
        attrs: {
          "count": _vm.messageNotReadTotal
        }
      }, [_c('span', {
        staticStyle: {
          "padding-right": "10px"
        }
      }, [_vm._v("\n                    " + _vm._s(subItem.name) + "\n                  ")])]) : subItem.id === 13 && !_vm.whatsappNumber && Number(_vm.$cookies.get('sellerRegionId')) !== 2 ? _c('Badge', {
        attrs: {
          "dot": ""
        }
      }, [_c('span', {
        staticStyle: {
          "padding-right": "10px"
        }
      }, [_vm._v("\n                    " + _vm._s(subItem.name) + "\n                  ")])]) : _c('span', [_vm._v("\n                  " + _vm._s(subItem.name) + "\n                ")])], 1);
    })], 2);
  })], 2)], 1)], 1), _vm._v(" "), _c('Col', {
    staticClass: "main",
    attrs: {
      "span": "20"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "190",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "seller-app-download"
  }, [_c('p', {
    staticClass: "download-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('sc.sellerCenter.downloadAppleApp')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "download-img"
  }, [_c('img', {
    staticClass: "google-play-qr",
    attrs: {
      "src": "https://image.kilimall.com/seller-pc/new_seller_app_qr.png",
      "alt": "apple"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "download-img"
  }, [_c('img', {
    staticClass: "google-play-img",
    attrs: {
      "src": "https://image.kilimall.com/kenya/PcImages/static/google-play.png",
      "alt": "apple"
    },
    on: {
      "click": function ($event) {
        return _vm.downLoadAppClick(2);
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function ($event) {
        return _vm.downLoadAppClick(1);
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('sc.sellerCenter.directDownload')) + "\n                ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "help-center",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('sc.sellerCenter.sellerApp')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "help-center",
    on: {
      "click": _vm.goFeedbackAndComplaint
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('sc.sellerCenter.feedbackAndComplaint')) + "\n              "), _c('el-icon', {
    attrs: {
      "size": "16",
      "name": "edit-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "help-center",
    on: {
      "click": _vm.goHelpCenter
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('sc.sellerCenter.sellerUniversity')) + "\n              "), _c('Icon', {
    attrs: {
      "type": "md-open",
      "color": "#999",
      "size": 16
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "on-change": _vm.switchStore
    },
    model: {
      value: _vm.storeId,
      callback: function ($$v) {
        _vm.storeId = $$v;
      },
      expression: "storeId"
    }
  }, _vm._l(_vm.storeList, function (item) {
    return _c('Option', {
      key: item.storeName,
      attrs: {
        "value": item.storeId
      }
    }, [_vm._v("\n                " + _vm._s(("(" + (item.storeId) + ")" + (item.storeName))) + "\n              ")]);
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "set-language"
  }, [_c('LocalSet')], 1), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-item"
  }, [_c('Dropdown', {
    on: {
      "on-click": _vm.menuChange
    },
    scopedSlots: _vm._u([{
      key: "list",
      fn: function () {
        return [_c('DropdownMenu', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('DropdownItem', {
          attrs: {
            "name": "Login",
            "divided": ""
          }
        }, [_vm._v("\n                      " + _vm._s(_vm.$t('sc.sellerCenter.loginOut')) + "\n                    ")])], 1)];
      },
      proxy: true
    }])
  }, [_c('span', [_c('Avatar', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "src": _vm.avatar,
      "onerror": _vm.avatarError
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v("\n                  " + _vm._s(_vm.userName) + "\n                ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('RouterTab', {
    attrs: {
      "i18n": _vm.i18n,
      "page-transition": {
        duration: 0
      },
      "tabs": _vm.tabs
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer",
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sc.sellerCenter.footer')) + " " + _vm._s(new Date().getFullYear()) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cn_chat_div"
  }, [_c('div', {
    staticClass: "cn_chat_qrd_div"
  }, [_c('img', {
    attrs: {
      "src": "https://image.kilimall.com/kenya/qrcode/chat_qr_icon.png",
      "alt": "wx_chat_qrc"
    }
  }), _vm._v("\n            扫码联系客服\n          ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://image.kilimall.com/kenya/seller/chat_icon.png",
      "alt": "chat_icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "en_chat_div",
    on: {
      "click": _vm.chatClick
    }
  }, [_c('img', {
    attrs: {
      "src": "https://image.kilimall.com/kenya/seller/chat_icon.png",
      "alt": "chat_icon"
    }
  })])])], 1)], 1), _vm._v(" "), _c('DepositPromoDialog', {
    attrs: {
      "visible": _vm.depositPromoVisible,
      "detail-data": _vm.depositPromoDetail
    },
    on: {
      "update:visible": function ($event) {
        _vm.depositPromoVisible = $event;
      },
      "completed": _vm.onDepositPromoCompleted
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }